<div class="app-header">
  <div class="header-item hamburger-menu">
    <i auto="back-to-dash" [ngClass]="['eleot-icon', actionLeft.icon]" (click)="actionLeft.action()"
       [pTooltip]="actionLeft.tooltip" tooltipStyleClass="strategies-tooltip"></i>
  </div>
  <div class="header-item app-logo">
    <img src="assets/images/strategies-icon-capital+icon.svg" alt="eprove&trade; strategies">
  </div>
  <div class="header-item menu-container">
    <div class="menu-toggle">
      <button class="btn btn-styleless" type="button" pButton (click)="menu.toggle($event)">
          <span class="welcome-txt">Welcome,</span>
          <span>{{user.firstName}}</span>
          <i class="fa fa-caret-down"></i>
      </button>
      <p-menu #menu styleClass="auth-user-menu" popup="popup" [model]="items" appendTo="body"></p-menu>
    </div>
  </div>
</div>
